﻿export default class Facebook {
    constructor() {
        this.appId = "2912722442128946";
        this.permissions = ["email", "public_profile"];
        //this.permissions = ["email", "public_profile", "user_friends"];
    }
    canUse(){
        return (typeof facebookConnectPlugin !== 'undefined');
    }
    deviceready() {
        return new Promise(function (resolve, reject) {
            if (typeof (cordova) === 'undefined') return reject('Cordova not found');
            document.addEventListener("deviceready", resolve, false);
            setTimeout(function () { reject(new Error('deviceready has not fired after 5 seconds.')); }, 5100);
        });
    };
    login() {
        return new Promise((resolve, reject) => {
            this.deviceready().then(() => {
                if (typeof facebookConnectPlugin === 'undefined') return reject('facebook plugin not found');

                facebookConnectPlugin.login(this.permissions,
                    function loginSuccess(userData) {
                        console.log("UserInfo: ", userData);
                        facebookConnectPlugin.getAccessToken(function (token) {
                            console.log("Token: " + token);
                            this.getInfo(token).then( (data) =>{
                                resolve(data);
                             });
                        }.bind(this));

                    }.bind(this),
                    function loginError(error) {
                        reject(error)
                    }.bind(this));

            });
        });
    }
    getInfo(accessToken) {
        return new Promise((resolve, reject) => {
            if (typeof facebookConnectPlugin === 'undefined') reject('facebook plugin not found');

            facebookConnectPlugin.api("/me?fields=id,name,first_name,email", null,
                function onSuccess(data) {
                    console.log(JSON.stringify(data));
                    data.accessToken = accessToken;
                    resolve(data);
                }, function onError(error) {
                    reject(data);
                }
            );
        });
    }
    getFriends(callback) {
        if (typeof facebookConnectPlugin === 'undefined') return;

        facebookConnectPlugin.api("/me/friends", null,
            function onSuccess(data) {
                console.log(JSON.stringify(data));
                if (callback) {
                    callback(data);
                }
            }, function onError(error) {
                if (callback) {
                    callback(data);
                }
            });
    }



    share(url, title,message) {
        return new Promise((resolve, reject) => {
            if (typeof facebookConnectPlugin === 'undefined') return;
            var options = {
                method: "share",
                href: url,
                caption: title,
                description: message,
                //picture: null,
                hashtag: '#cribbage',
                share_feedWeb: true, // iOS only
            }
            facebookConnectPlugin.showDialog(options, function onSuccess(data) {
                console.log(JSON.stringify(data));
                    resolve(data);
            }, function onError(error) {
                    reject(error);
            });
        });
    }
}
